import { useEffect, useRef } from 'react'

import css from './sass/itemfilter.module.scss'

export default function ItemFilter({ filterInput, setFilterInput, isFilterOpen, setIsFilterOpen }) {
  const inputRef = useRef(null)

  useEffect(() => {
    if (isFilterOpen) {
      inputRef.current?.focus()
    }
  }, [isFilterOpen])

  const toggleFilterOpen = () => {
    setIsFilterOpen((currentState) => !currentState)
  }

  const closeFilter = () => {
    setIsFilterOpen(false)
    inputRef.current?.blur()
  }

  const clearFilter = () => {
    setFilterInput('')
    inputRef.current?.focus()
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      closeFilter()
    }
  }

  return (
    <div className={`${css['item-filter']} ${isFilterOpen ? css['item-filter-open'] : ''}`}>
      <button
        type="button"
        className={css['item-filter-button']}
        onClick={toggleFilterOpen}
        aria-label={isFilterOpen ? 'Close item filter' : 'Open item filter'}
        aria-expanded={isFilterOpen}
      >
        <span className={css['item-filter-icon']} aria-hidden="true">⌕</span>
      </button>

      <div className={css['item-filter-input-shell']}>
        <label className={css['sr-only']} htmlFor="auction-item-filter-input">Search auction items</label>
        <input
          id="auction-item-filter-input"
          ref={inputRef}
          type="text"
          autoComplete="off"
          className={css['item-filter-input']}
          placeholder="Search items"
          value={filterInput || ''}
          onChange={(event) => setFilterInput(event.target.value)}
          onKeyDown={handleKeyDown}
          tabIndex={isFilterOpen ? 0 : -1}
        />

        {isFilterOpen && filterInput &&
          <button
            type="button"
            className={css['item-filter-clear-button']}
            onClick={clearFilter}
            onMouseDown={(event) => event.preventDefault()}
            aria-label="Clear item filter"
          >
            ×
          </button>}
      </div>
    </div>
  )
}
